<template>
  <div class="wizard-step-2">
    <document-summary
      :type="selectedDocumentInfo"
      :icon="icon"
      :description="description"
    />
    
    <location-breadcrumb
      :location="location"
    />
    
    <b-alert show variant="info" class="info-alert">
      <feather-icon icon="InfoIcon" size="18" class="mr-2" />
      El documento se creará en la ubicación actual del repositorio.
    </b-alert>
  </div>
</template>

<script>
import DocumentSummary from './DocumentSummary.vue';
import LocationBreadcrumb from './LocationBreadcrumb.vue';

export default {
  name: 'WizardStep2Confirm',
  components: {
    DocumentSummary,
    LocationBreadcrumb
  },
  props: {
    selectedType: {
      type: String,
      required: true
    },
    documentTypes: {
      type: Array,
      required: true
    },
    location: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectedDocumentInfo() {
      return this.documentTypes.find(t => t.value === this.selectedType) || {};
    },
    
    icon() {
      const icons = {
        'OF': '📄', 'MEMO': '📝', 'SP': '📋', 'RES': '📑',
        'BIT': '🚗', 'ACUCORE': '✅', 'OFCORE': '📄', 'ODP': '💰',
        'RESUGDPS': '📑', 'SCP': '✈️', 'INF': '📊', 'SOGR': '💵',
        'SEGR': '🏢', 'IDPC': '📈', 'SCH': '📝', 'GRC': '✅',
        'CPSH': '📄', 'FISABS': '📋', 'ACT': '📊', 'AF': '🔍',
        'ADP': '⏰', 'SV': '📨'
      };
      return icons[this.selectedType] || '📄';
    },
    
    description() {
      const descriptions = {
        'OF': 'Comunicación oficial externa',
        'MEMO': 'Comunicación interna formal',
        'SP': 'Solicitud de recursos presupuestarios',
        'RES': 'Resolución administrativa',
        'BIT': 'Bitácora de vehículos fiscales',
        'ACUCORE': 'Acuerdos del Consejo Regional',
        'OFCORE': 'Oficio del Consejo Regional',
        'ODP': 'Orden de pago con cargo a gasto de representación',
        'RESUGDPS': 'Resolución de la Unidad de Gestión',
        'SCP': 'Solicitud de pasajes para comisión',
        'INF': 'Informe de uso y custodia de vehículos',
        'SOGR': 'Solicitud de gasto de representación',
        'SEGR': 'Selección de proveedor para gasto',
        'IDPC': 'Informe de desempeño y calificaciones',
        'SCH': 'Solicitud de convenio a honorarios',
        'GRC': 'Guía de recepción conforme',
        'CPSH': 'Convenio de prestación de servicios',
        'FISABS': 'Formulario de adquisición de bienes/servicios',
        'ACT': 'Informe de actividades realizadas',
        'AF': 'Acta de proceso de fiscalización',
        'ADP': 'Solicitud de aumento de plazo',
        'SV': 'Solicitudes diversas'
      };
      return descriptions[this.selectedType] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.wizard-step-2 {
  .info-alert {
    display: flex;
    align-items: center;
    border-radius: 8px;
    font-size: 0.95rem;
    
    svg {
      flex-shrink: 0;
    }
  }
}
</style>
